import { SuperLink as BrandSuperLink } from '@lce/brand';
import styled from 'styled-components';

export const SuperLink = styled(BrandSuperLink)`
  text-decoration: none;
  color: inherit;
  :hover {
    text-decoration: none;
  }
`;
